// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMessageSquareText as RawLucideMessageSquareText } from "lucide-react";
export const LucideMessageSquareText = /* @__PURE__ */ createIcon(RawLucideMessageSquareText, "LucideMessageSquareText", 2);
